<template>

	<div class="p--login container-fluid bg-white p-0">
		<div class="row row-login align-items-center m-0">

			<div class="col col-sl bg-white p-0">

				<div class="card">
					<div class="card-body">
						<div class="p-15">
							<a :href="$store.state.settings.path">
								<div class="m-b-30 text-center">
									<img
										class="img-fluid inline-block"
										style="max-height: 60px"
										:src="$store.state.settings.logotipo"
										alt="App logo"
									/>
									<!-- <h2 class="inline-block pull-right m-0 align-middle pl-3 text-uppercase">{{ $store.state.settings.name }}</h2> -->
									<hr />
								</div>
							</a>
							<router-view />
						</div>
					</div>
				</div>

			</div>

			<div class="col col-sr p-0 d-xl-block d-lg-none d-md-none d-none" :style="{'background-image': 'url(' + $store.state.settings.background + ')',}">
				
			</div>

		</div>
	</div>
	
</template>

<style>
.row-login {
	min-height: 100vh;
}
.col-sl {
	max-width: 500px;
	@media only screen and (max-width: 1024px) {
		max-width: 100%;
	}
}
.col-sr {
	min-height: 100vh;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
}
</style>

<script>
export default {
	name: "Auth",
	metaInfo() {
		return {
			title: this.$i18n.t("Authentication"),
		};
	},
	data() {
		return { isRegister: false };
	},
	mounted() {
		this.$route.name == "register"
		? (this.isRegister = true)
		: (this.isRegister = false);
	},
};
</script>